;(function () {
  'use strict'

  angular
    .module('common.services')
    .service('configurationService', configurationService)

  configurationService.$inject = ['$localStorage']

  function configurationService ($localStorage) {
    var LS_VERSION_SUPPORT_KEY = 'newVersionSupport'

    var config = {
      isNewVersionSupported:
        APP_V2_SUPPORT && $localStorage[LS_VERSION_SUPPORT_KEY]
    }

    var api = {
      getState: getState,
      setNewVersionSupportState: setNewVersionSupportState,
      getVersionSupportState: getVersionSupportState
    }

    function getState () {
      return config
    }

    function setNewVersionSupportState (state) {
      var versionIsSupported = APP_V2_SUPPORT && state
      config.isNewVersionSupported = versionIsSupported
      $localStorage[LS_VERSION_SUPPORT_KEY] = versionIsSupported
    }

    function getVersionSupportState () {
      return config.isNewVersionSupported
    }

    return api
  }
})(angular)
